export default "__VITE_ASSET__Dyd3E4ja__"